<h2 mat-dialog-title>{{titleMessage}}</h2>
<mat-dialog-content>
  {{ customMessage || defaultMessage }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-{{ colorButton }} text-white">Confirmer</button>
</mat-dialog-actions>
